
interface ConcentrationSettings{
    checkPoint:any
    skipDuration:number
}
interface ConcentrationCheckPointInteface{
    showAnswerDialogDuration:number
    showQuestionDailogDuration:number
    isShowAnswerDialogTrigger:boolean
    isShowQuestionDailogTrigger:boolean
    restartDuration:number
}

interface ILiteEvent<T> {
    on(handler: { (data?: T): void }) : void;
    off(handler: { (data?: T): void }) : void;
}

class LiteEvent<T> implements ILiteEvent<T> {
    private handlers: { (data?: T): void; }[] = [];

    public on(handler: { (data?: T): void }) : void {
        this.handlers.push(handler);
    }

    public off(handler: { (data?: T): void }) : void {
        this.handlers = this.handlers.filter(h => h !== handler);
    }

    public trigger(data?: T) {
        this.handlers.slice(0).forEach(h => h(data));
    }

    public expose() : ILiteEvent<T> {
        return this;
    }
}

export default class Concentration {
    interval:any;
    settings:ConcentrationSettings;
    concentrationCheckPoint:any[] =[];
    currentDuration:number =0;
    currentConcentrationCheckPoint?:ConcentrationCheckPointInteface;

    private readonly onLogin = new LiteEvent<string>();
    private readonly onLogout = new LiteEvent<void>();

    public get LoggedIn() { return this.onLogin.expose(); } 
    public get LoggedOut() { return this.onLogout.expose(); }

    /**
     *
     */
    constructor(settings:any) {
        this.settings = settings;
        this.init();
        //console.log(JSON.stringify(this.concentrationCheckPoint));
        if(this.concentrationCheckPoint.length>0)
        this.interval = setInterval(this.ConcentrationFlow.bind(this) , 1000);
        //this.GetNextConcentrationCheckPoint();            
    }
    init(){
        for (let index = 0; index < this.settings.checkPoint.length; index++) {
            const result =this.GetConcentrationCheckPoint(index);
            if(result.skip === false){
                this.concentrationCheckPoint.push({
                    showAnswerDialogDuration:result.showAnswerDialogDuration,
                    showQuestionDailogDuration:result.showQuestionDailogDuration,
                    isShowAnswerDialogTrigger:false,
                    isShowQuestionDailogTrigger:false 
                }
                );
            }
            
        }
        
    }

    CurrentDuration(duration:number){
        this.currentDuration =duration;
    }


    ConcentrationFlow(){
        if(this.currentConcentrationCheckPoint === undefined)
        return;

        // Should just return if different too much, drag on timeline? Back to last play
        let durationVsQuestion = this.currentDuration - this.currentConcentrationCheckPoint.showQuestionDailogDuration;
        let durationVsAnswer = this.currentDuration - this.currentConcentrationCheckPoint.showAnswerDialogDuration;
        
        //  console.log("Current Duration : " + this.currentDuration);
        //  console.log("durationVsQuestion : " + durationVsQuestion);
        //  console.log("showQuestionDailogDuration : " + this.currentConcentrationCheckPoint.showQuestionDailogDuration);
        //  console.log("showAnswerDialogDuration : " + this.currentConcentrationCheckPoint.showAnswerDialogDuration);
                
        if((durationVsQuestion > 0 && durationVsQuestion < 1.2) &&   
            this.currentDuration > this.currentConcentrationCheckPoint.showQuestionDailogDuration){
            if(this.currentConcentrationCheckPoint.isShowQuestionDailogTrigger === false){
                this.currentConcentrationCheckPoint.isShowQuestionDailogTrigger = true;

                // console.log("Popup Question");
                // this.onLogout.trigger();
                // Answer shown only can show concentration
                if(this.currentConcentrationCheckPoint.isShowAnswerDialogTrigger === true){
                    //console.log("Popup Question");
                    this.onLogout.trigger();
                }
            }
        }
        else if(
            (durationVsAnswer > 0 && durationVsAnswer < 1.2) &&   
            this.currentDuration> this.currentConcentrationCheckPoint.showAnswerDialogDuration){
            if(this.currentConcentrationCheckPoint.isShowAnswerDialogTrigger === false){
                this.currentConcentrationCheckPoint.isShowAnswerDialogTrigger =true;
                console.log("Popup Answer");
                this.onLogin.trigger();
            }
        }
          

    }

    GetRepeatConcentrationCheckPointRestartDuration(){
        if(this.currentConcentrationCheckPoint === undefined){
            return 0;
        }else{
            return this.currentConcentrationCheckPoint.restartDuration;
        }
    }

    RepeatConcentrationCheckPoint(){
        if(this.currentConcentrationCheckPoint === undefined)
        return 0;

        this.currentConcentrationCheckPoint = {
            ...this.currentConcentrationCheckPoint , 
            isShowAnswerDialogTrigger:false,
            isShowQuestionDailogTrigger:false};
        return this.currentConcentrationCheckPoint.restartDuration;
    }

    GetNextConcentrationCheckPoint(restartDuration:number){
        this.currentConcentrationCheckPoint = {...this.concentrationCheckPoint.shift(),restartDuration:restartDuration};
    }

    private GetConcentrationCheckPoint(index:number):{skip:boolean,showAnswerDialogDuration?:number,showQuestionDailogDuration?:number}{
        let returnResult:any = {skip:true};
        const concentrationCheckPoint = this.settings.checkPoint[index];
        let durations = concentrationCheckPoint.duration.filter( (f:number) => f>this.settings.skipDuration)
            //Replay does not need to concentrationCheckPoint
        if(durations.length>0)
        {
            let stopDuration:number = durations[this.getRandomInt(durations.length-1)];

            if(concentrationCheckPoint.AnswerSpot > this.settings.skipDuration )
            {
                returnResult = {skip:false , 
                    showAnswerDialogDuration:stopDuration, 
                    showQuestionDailogDuration:concentrationCheckPoint.AnswerSpot }
                
            }
        
        }

        return returnResult;
    }
    getRandomInt(max:number) {
        return Math.floor(Math.random() * Math.floor(max));
    }

}